/* eslint-disable security/detect-object-injection */
/* istanbul ignore file */
// BarcodeGenerator.js

import React, { useContext, useEffect, useRef, useState } from 'react';
import bwipjs from 'bwip-js';
import JsBarcode from "jsbarcode";
import { isValidDeltaOps, quillGetHTMLWithBlot, replaceMergeFieldsInHtml } from '../../../../../helpers/CommonFunctions';
import ApplicationContext from '../../../../../context/ApplicationContext';

const BarcodeGenerator = (props) => {

    const { component } = props;
    const barcodeRef = useRef(null);
    const { mergeFieldValues } = useContext(ApplicationContext);

    const generateBarcode = (value) => {
        try {
            // The return value is the canvas element
            let canvas = bwipjs.toCanvas(`view-${component?.component_id}`, {
                bcid:        component.properties?.barcodeType.split(' ').join('').toLowerCase(),       // Barcode type
                text:        value,    // Text to encode
                scale:       1,               // 3x scaling factor
                // height:      10,              // Bar height, in millimeters
                includetext: false,            // Show human-readable text
                textxalign:  'center',        // Always good to set this
            });
            // barcodeRef.current.value = canvas;
        } catch (e) {
            console.warn(e)
            // `e` may be a string or Error object
        }
    };

    const generateBarcodeUsingJSBarcode = (value) => {
        try {
            const canvasElement = document.getElementById(`view-${component.component_id}`);
            if (canvasElement) {
                JsBarcode(canvasElement, value, {
                    format: component?.properties?.barcodeType.split(" ").join("").toUpperCase(), // Ensure correct format
                    lineColor: "#000",
                    // width: 2,
                    // height: 100,
                    displayValue: component?.properties?.display_text,
                    // fontSize: '5px'
                });
            } else {
                console.warn("Canvas element not found:", component.component_id);
            }
        } catch (error) {
            console.warn("Failed to generate barcode in form:", error);
        }
    }

    useEffect(() => {
        if (!isValidDeltaOps(component.barcode_text)) {
            console.warn("Delta is empty or default. Skipping barcode generation.");
            return;
        }
        const html = quillGetHTMLWithBlot(component.barcode_text)
        const finalHTML = replaceMergeFieldsInHtml(html, mergeFieldValues)
        const tempElement = document.createElement('div');
        tempElement.innerHTML = finalHTML;
        const value =  tempElement.textContent || tempElement.innerText || ''
        const finalValue = value.replace(/\u00A0/g, ' ').replace(/^\uFEFF/, '').trim();
        if(component.properties?.barcodeType?.includes('code')) {
            generateBarcodeUsingJSBarcode(finalValue);
        } else if (component.properties?.barcodeType){
            generateBarcode(finalValue);
        }
    }, [component]);
    
    return (
        <div>
            {component?.properties?.barcodeType && isValidDeltaOps(component?.barcode_text)  ? 
                <canvas id={`view-${component?.component_id}`} className='barcode-class' /> : 
                <div>
                    <img src="/images/barcode-placeholder.svg" alt="barcode" />
                </div>
            }
        </div>
    );
};

export default BarcodeGenerator;
